import { ClubPropertiesSettings } from "@gymflow/types";
import { createContext } from "react";

export type ClubSettings = ClubPropertiesSettings;

export const ClubSettingsContext = createContext<ClubSettings | undefined>(
  undefined,
);
